<template>
  <BaseModal
    ref="modal"
    class="modal-requirements"
    v-bind="attributes"
    v-on="$listeners"
  >
    <BaseTitle
      v-if="title"
      v-bind="title"
      class="modal-requirements__title"
    />
    <ul class="modal-requirements__list">
      <li
        v-for="(item, i) in requirements"
        :key="`requirement_${i}`"
        v-text="item"
        class="modal-requirements__list-item"
      />
    </ul>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/BaseModal.vue';
import BaseTitle from '@/components/BaseTitle.vue';

export default {
  name: 'ModalRequirements',
  components: {
    BaseModal,
    BaseTitle,
  },
  props: {
    requirements: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    title() {
      return {
        text: this.$t('titles.fieldRequirement'),
        size: 'l',
        isNormal: true,
      };
    },
    attributes() {
      return {
        hasCloseButton: false,
        isMiddle: true,
        actions: [
          {
            text: this.$t('actions.close'),
            action: this.close,
          },
        ],
        ...this.$attrs,
      };
    },
  },
  methods: {
    close() {
      return this.$refs.modal?.close();
    },
  },
};
</script>

<style lang="stylus">
.modal-requirements
  &__title
    margin-bottom 0.7em

  &__list
    display block
    list-style none
    padding 0
    margin 0
    &-item
      font-size 1em
      line-height 1.5
      padding 0 0 0 1.6em
      margin-top 0.8em
      &:before
        content '\25CF'
        display block
        float left
        color currentColor
        margin-left -1.5em
</style>
